import { useState } from "react";
import { Tooltip } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import LabelDestinos from "./../../Paquetes/LabelDestinos";
import { Divider } from "@material-ui/core";
import { TPaquetesStyle } from "./styles";
import { useSelector } from "react-redux";
const columns = [
  {
    id: "FolioPaquete",
    minWidth: 50,
    align: "center",
    label: "Folio",
  },
  {
    id: "Nombrepaquete",
    minWidth: 150,
    align: "center",
    label: "Nombre paquete",
  },
  { id: "Origen", minWidth: 150, align: "center", label: "Origen / Destinos" },
  { id: "Dias", minWidth: 150, align: "center", label: "Dias / Noches" },
  { id: "Accion", minWidth: 30, align: "center", label: "" },
];

export default function TPaquetes(props) {
  const {
    onGaleria = () => { },
  } = props;
  const rows = useSelector((store) => store.paquetesImagen.array)
  const classes = TPaquetesStyle();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    key={row.IdPaquete}
                  >
                    <TableCell align="center">{row.FolioPaquete}</TableCell>
                    <TableCell align="center">{row.Nombre}</TableCell>
                    <TableCell align="center">
                      <div className={classes.section1}>
                      {row.Origen && (
                            <p>{`${row.Origen.Pais.Nombre} - ${row.Origen.Nombre} `}</p>
                          )}
                      </div>
                      <Divider variant="middle" />
                      <div className={classes.section2}>
                        <LabelDestinos Destinos={row.Destinos} />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div className={classes.section1}>
                      <p>{`Dias: ${row.Dias}`}</p>
                      </div>
                      <Divider variant="middle" />
                      <div className={classes.section2}>
                      <p>{`Noches: ${row.Noches}`}</p>
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div className={classes.ButtonContent}>
                      <Tooltip title="Galeria">
                        <IconButton
                          aria-label="Salidas"
                          onClick={() => {
                            onGaleria(row);
                          }}
                        >
                          <PhotoLibraryIcon />
                        </IconButton>
                      </Tooltip>
                      </div>

                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
